import OpenedImageFachada from "./OpenedImageFachada";

export default OpenedImageFachada;
